import React from "react";
import { Card, CardMedia, CardContent, Typography, CardActions, IconButton, Box } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

const BrochureItem = ({
  item,
  onEdit,
  onDelete,
  onSelect,
  viewMode = false,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        width: 260,
        borderRadius: 4,
        border: "1px solid #eef2f6",
        boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
        cursor: "pointer",
        textAlign: "center",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
        },
      }}
    >
      <Box onClick={(e) => { e.stopPropagation(); onSelect(item); }}>
        <CardMedia
          component="img"
          image={item.preview}
          alt={item.title}
          sx={{ height: 160, objectFit: "cover" }}
        />
        <CardContent sx={{ padding: 2, paddingBottom: viewMode ? 2 : 1 }}>
          <Typography variant="h6" color="#1e293b" fontWeight={500} noWrap>
            {item.title}
          </Typography>
        </CardContent>
      </Box>
      {!viewMode && (
        <CardActions sx={{ justifyContent: "center", backgroundColor: "#e2e8f0", padding: "10px", marginTop: "auto" }}>
          <IconButton
            size="small"
            aria-label="edit"
            onClick={(e) => { e.stopPropagation(); onEdit(item); }}
            sx={{ color: "#64748b", "&:hover": { color: "#0f4a5f" } }}
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            aria-label="delete"
            onClick={(e) => { e.stopPropagation(); onDelete(item); }}
            sx={{ color: "#64748b", "&:hover": { color: "#d32f2f" } }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </CardActions>
      )}
    </Card>
  );
};

export default BrochureItem;
